export function getValueByName(field, nameKey) {
    if (!field || !field.options) return null;
    const match = field.options.find(opt => opt.name === nameKey);
    return match?.value || null;
  }